import styled from "styled-components";

const Main = styled.main`
	margin: 0 auto;
	max-width: 58rem;
	padding: 0 2.1rem;
`;

export default Main;
